<template lang="html">
  <v-bottom-sheet v-model="detail_product.sheet" persistent content-class="sheet-full">
    <v-sheet style="height: 100%" class="br-0">
      <div class="sheet-app-bar">
        <div class="sheet-app-bar-content">
          <v-container class="px-0">
            <v-row>
              <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
                <div class="d-flex align-center">
                  <div class="font-20 font-weight-bold">
                    {{ isEdit ? $t('v2.change_menu') : $t('v2.add_menu') }}
                  </div>
                  <v-spacer />
                  <v-btn icon width="40" height="40" @click="closeSheet">
                    <v-icon>
                      mdi-close
                    </v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>
      <v-form id="addCartItems">
        <v-container class="pt-0">
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
              <div class="image-product-detail">
                <div class="image-full">
                  <v-carousel cycle interval="8000" :show-arrows="false" class="carousel-product">
                    <v-carousel-item v-for="(item, i) in image_product" :key="i" reverse-transition="fade-transition" transition="fade-transition">
                      <div class="d-flex align-center justify-center fill-height">
                        <img
                          :src="item"
                          class="image-responsive obj-fit-cover"
                          @error="imageLoadError"
                        >
                      </div>
                    </v-carousel-item>
                    <!-- <v-carousel-item v-for="(item, i) in image_product" :key="i" :src="item" reverse-transition="fade-transition" transition="fade-transition" /> -->
                  </v-carousel>
                </div>
              </div>
              <div v-if="orderAtCashier && !isOutStock" class="mt-4 col-order-cashier">
                <div class="order-cashier-icon">
                  <v-icon color="#FF931E" size="19">
                    mdi-alert-outline
                  </v-icon>
                </div>
                <div class="order-cashier-content">
                  <div class="order-cashier-text">
                    {{ $t('v2.product_only_be_ordered_at_the_cashier') }}
                  </div>
                </div>
              </div>
              <div class="mt-4 title-product-detail">
                {{ detail_product.item.name }}
              </div>
              <div v-if="detail_product.item.alt_name" class="mt-1 title-product-detail">
                {{ detail_product.item.alt_name }}
              </div>
              <div v-if="isOutStock" class="font-18 font-weight-700 mt-3 ol-red">
                {{ $t('v2.out_of_stock') }}
              </div>
              <div v-if="html_description !== ''" class="mt-4">
                <div :class="[`desc-product-detail animate-fade`, { 'is-more': is_more }]" v-html="html_description" />
                <span class="more-less" @click="is_more = !is_more">
                  {{ !is_more ? $t('v2.more') : $t('v2.less') }}
                </span>
              </div>
              <div v-if="!orderAtCashier && !isOutStock" class="mt-4">
                <div class="font-price">
                  <span v-mask-money="price" />
                  <span v-if="market_price > 0" v-mask-money="market_price" class="market-price" />
                </div>
              </div>
              <div v-if="!orderAtCashier && detail_product.item.items && detail_product.item.items.length !== 0 && !isOutStock" class="mt-6">
                <div class="title-section mb-2">
                  <div :class="[`title-combo-subtext`, { 'error-variant': error_variant && !form.product_combo_items[idx] }]">
                    Item Paket ({{ detail_product.item.items.length }})
                  </div>
                </div>
                <div class="group-list-combo">
                  <div v-for="(item, idx) in tempSelectedCommodity" :key="idx + '_items'" class="list-frame-item-combo">
                    <div class="item-combo-with-image px-4 py-2 cursor-pointer" @click="openCombo(idx)">
                      <div :class="['item-combo-with-image-avatar', { 'item-combo-image-disable': item.disabled }]">
                        <img :src="item.image" :alt="item.name" @error="imageLoadError">
                      </div>
                      <div class="item-combo-with-image-content">
                        <div class="item-combo-with-image-title font-weight-600 font-14">
                          {{ item.qty }}x {{ item.name }}
                        </div>
                        <div v-if="item.disabled" class="font-12 font-weight-600 ol-red">
                          {{ $t('v2.out_of_stock') }}
                        </div>
                        <div v-else class="font-12 font-weight-600 color-767676">
                          {{ commodity[idx].length }} pilihan
                        </div>
                      </div>
                      <div>
                        <v-icon>
                          mdi-chevron-right
                        </v-icon>
                      </div>
                    </div>
                    <div v-if="item.addons.length > 0">
                      <div class="line-item-combo" />
                      <div class="group-addons-combo">
                        <div class="px-4 py-2 group-addons-title">
                          {{ $t('v2.add_ons') }}
                        </div>
                        <template v-for="(addon, i) in item.addons">
                          <div v-if="addon.product_status !== 'X'" :key="i + addon.name" class="addons-item px-4">
                            <div class="addons-item-content">
                              <div class="addons-item-title">
                                {{ addon.name }}
                              </div>
                            </div>
                            <div class="addons-item-action">
                              <span v-mask-money="addon.price" class="font-14 font-weight-600 text-right" />
                              <v-checkbox v-model="combo_addons[idx][i].selected" hide-details class="mt-0 pt-0 ml-2" />
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="!orderAtCashier && detail_product.item.variants && detail_product.item.variants.length !== 0 && !isOutStock" class="col-variant mt-6">
                <div v-for="(variant, idx) in detail_product.item.variant_tag" :key="idx">
                  <div class="title-section">
                    <div class="title-section-text">
                      {{ variant.label }}
                    </div>
                    <div :class="[`title-section-subtext`, { 'error-variant': error_variant && (typeof variant_group[idx] === 'undefined')}]">
                      {{ $t('v2.select_one') }}
                    </div>
                  </div>
                  <div class="variant-content">
                    <v-radio-group v-model="variant_group[idx]" hide-details class="mt-0 list-variant-tag" @change="selectVariant()">
                      <v-radio v-for="(detail, i) in variant.detail" :key="i" :label="detail" color="olbrand" :value="detail" :ripple="false" class="list-variant-tag-item" />
                    </v-radio-group>
                  </div>
                  <div class="my-2 py-2">
                    <hr class="line-variant">
                  </div>
                </div>
              </div>
              <div v-if="!orderAtCashier && detail_product.item.addons && detail_product.item.addons.length !== 0 && !isOutStock" class="mt-4">
                <div class="title-section">
                  <div class="title-section-text">
                    {{ $t('v2.add_ons') }}
                  </div>
                  <div class="title-section-subtext">
                    {{ $t('v2.optional') }}
                  </div>
                </div>
                <div class="addons-content">
                  <div>
                    <template v-for="(item, idx) in detail_product.item.addons">
                      <div v-if="item.product_status !== 'X'" :key="idx + '-product-addons'" class="addons-item">
                        <div class="addons-item-content">
                          <div class="addons-item-title">
                            {{ item.name }}
                          </div>
                        </div>
                        <div class="addons-item-action">
                          <span v-mask-money="(item.total_price != null ? item.total_price : item.price)" class="font-14 font-weight-600 text-right" />
                          <v-checkbox v-model="item_addons[idx]" hide-details class="mt-0 pt-0 ml-2" />
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="mt-2 py-2">
                  <hr class="line-variant">
                </div>
              </div>
              <div v-if="!orderAtCashier && !isOutStock" class="mt-6">
                <div class="font-12 ol-black">
                  {{ $t('v2.note') }}
                </div>
                <div>
                  <v-textarea v-model="form.note" :placeholder="$t('v2.write_note')" hide-details outlined height="80" :append-icon="list_note.length !== 0 ? 'mdi-dots-vertical' : ''" @click:append="openDialogNote" />
                </div>
              </div>
              <div v-if="!orderAtCashier && !isOutStock" class="my-6">
                <div class="qty-wrap">
                  <div>
                    <v-btn min-width="54" height="40" :disabled="disabled" :ripple="false" class="btn-plus-minus" @click="minus">
                      <v-icon size="22">
                        mdi-minus
                      </v-icon>
                    </v-btn>
                  </div>
                  <div class="mx-4">
                    <div class="font-18 font-weight-700 ol-black prevent-select">
                      {{ form.qty }}
                    </div>
                  </div>
                  <div>
                    <v-btn min-width="54" height="40" :ripple="false" class="btn-plus-minus" @click="plus">
                      <v-icon size="20">
                        mdi-plus
                      </v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
              <div v-if="disabledAdd && !orderAtCashier && !isOutStock" class="flex-image pa-4 bg-grey mb-2 br-10">
                <div class="mr-2">
                  <v-icon size="18">
                    mdi-alert-circle-outline
                  </v-icon>
                </div>
                <div class="flex-image-content">
                  <div class="flex-image-content-text font-14 font-weight-400 ol-black">
                    {{ $t('v2.complete_the_required_items') }}
                  </div>
                </div>
              </div>
              <template v-if="isEdit">
                <v-btn v-if="form.qty > 0 && !orderAtCashier && !isOutStock" block color="primary" height="40" class="text-none font-weight-700 btn-v2-shadow" @click="addToCart">
                  {{ $t('v2.save') }} (<span v-mask-money="sub_total" />)
                </v-btn>
                <v-btn v-else block color="White" height="40" :class="[`text-none font-weight-700 btn-v2-shadow`, { 'mt-6': orderAtCashier || isOutStock }]" @click="deleteItem">
                  {{ $t('v2.delete') }}
                </v-btn>
              </template>
              <template v-else>
                <v-btn v-if="form.qty > 0 && !orderAtCashier && !isOutStock" block color="primary" height="40" :class="[`text-none font-weight-700 btn-v2-shadow`, { 'disabled-add': disabledAdd }]" @click="addToCart">
                  {{ $t('v2.add') }} (<span v-mask-money="sub_total" />)
                </v-btn>
                <v-btn v-else block color="White" height="40" :class="[`text-none font-weight-700 btn-v2-shadow`, { 'mt-6': orderAtCashier || isOutStock }]" @click="closeSheet">
                  {{ $t('v2.back') }}
                </v-btn>
              </template>
            </v-col>
          </v-row>
        </v-container>
        <v-dialog v-model="dialog.list_note" max-width="290">
          <v-card class="card-view-image">
            <v-card-text class="pt-6">
              <template v-if="list_note.length > 0">
                <v-checkbox v-for="(item, idx) in list_note" :key="idx" v-model="listnote[idx]" :label="item" solo hide-details />
              </template>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn color="grey" text class="text-none" @click="dialog.list_note = false">
                {{ $t('v2.close') }}
              </v-btn>
              <v-btn color="primary" text class="text-none" @click="saveNote">
                {{ $t('v2.save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-form>
    </v-sheet>
    <alert v-model="alert.show" type="error" :message="alert.message" />
  </v-bottom-sheet>
</template>
<script>
import {
  checkMaterial as checkStockMaterial,
  validateMaterial
} from '@/api/product'
import Alert from '@/components/v2/Alert'
export default {
  name: 'Productv2',
  components: {
    Alert
  },
  props: {
    value: {
      default() {
        return {
          sheet: false,
          item: {}
        }
      },
      type: Object
    },
    isEdit: {
      default: false,
      type: Boolean
    },
    clickAddcart: {
      required: true,
      type: Function
    },
    clickDelete: {
      default: () => {},
      type: Function
    },
    defaultData: {
      default: () => {},
      type: Object
    },
    selectedIdxCommodity: {
      type: Object,
      default: () => ({
        selectedCommodity: {},
        combo_index: null
      })
    }
  },
  data() {
    return {
      dialog: {
        list_note: false
      },
      alert: {
        show: false,
        message: ''
      },
      error_message: '',
      is_more: false,
      form: {
        addons: [],
        has_material: 0,
        hold_qty: 0,
        is_out_stock: 0,
        klasifikasi_id: null,
        materials: [],
        min_order: 0,
        max_order: 0,
        name: '',
        non_service_charge: 0,
        non_taxable: 0,
        note: '',
        product_combo_id: null,
        product_combo_items: [],
        product_id: null,
        product_variant_id: null,
        product_variant_name: null,
        qty: 1,
        sell_price: 0,
        stock_qty: 0,
        sub_total: 0,
        track_inventory: 0
      },
      variant_group: [],
      item_addons: [],
      combo_addons: [],
      error_variant: false,
      listnote: [],
      cart: {},
      temp_cart: {},
      selectedCommodity: [],
      tempSelectedCommodity: []
    }
  },
  computed: {
    isOutStock() {
      if (typeof this.detail_product.item.items !== 'undefined') {
        if (this.detail_product.item.is_out_stock) {
          return true
        }
      } else {
        if (this.detail_product.item.has_variant) {
          let isDisabled = true
          for (let i = 0; i < this.detail_product.item.variants.length; i++) {
            const item = this.detail_product.item.variants[i]
            if (this.detail_product.item.track_inventory && this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
              if (!item.is_out_stock && Number(item.hold_qty) + this.$stockCart(item.id, '_v2_cart', 'variant', this.isEdit, this.detail_product.key) < Number(item.stock_qty)) {
                isDisabled = false
                break
              }
            } else {
              if (!item.is_out_stock) {
                isDisabled = false
                break
              }
            }
          }
          return isDisabled
        } else {
          if (this.detail_product.item.track_inventory && this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
            if (this.detail_product.item.is_out_stock || this.$stockCart(this.detail_product.item.id, '_v2_cart', 'product', this.isEdit, this.detail_product.key) + Number(this.detail_product.item.hold_qty) >= Number(this.detail_product.item.stock_qty)) {
              return true
            }
          } else {
            if (this.detail_product.item.is_out_stock) {
              return true
            }
          }
        }
      }
      return false
    },
    disabledAdd() {
      if (this.detail_product.type === 'product') {
        if (this.detail_product.item.has_variant && !this.form.product_variant_id) {
          return true
        } else {
          return false
        }
      } else {
        if (this.form.product_combo_items.length > 0 && this.detail_product.item.items.length === this.form.product_combo_items.length) {
          for (let i = 0; i < this.form.product_combo_items.length; i++) {
            if (typeof this.form.product_combo_items[i] === 'undefined') {
              return true
            }
          }
        } else {
          return true
        }
      }
      return false
    },
    commodity() {
      if (this.detail_product.type !== 'product_combo') return []
      if (!this.detail_product.item.items) return []
      return this.detail_product.item.items.map(item => {
        const list = []
        this.buildCommodityItem(item, list)

        if (item.children && item.children.length) {
          item.children.forEach(child => {
            this.buildCommodityItem(child, list, true)
          })
        }
        return list
      })
    },
    'detail_product': {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    html_description() {
      if (this.detail_product.item.description) {
        return (this.detail_product.item.description).replace(/\n/g, '<br />')
      } else {
        return ''
      }
    },
    orderAtCashier() {
      if (Number(this.detail_product.item.pos_sell_price_dynamic) === 1 && Number(this.$store.state.selected_outlet.setting.pos_dynamic_price_can_order) === 0) {
        return true
      } else {
        return false
      }
    },
    price() {
      let price = this.$usePosPrice() ? this.detail_product.item.sell_price_pos : this.detail_product.item.sell_price
      if (this.form.product_variant_id) {
        const idx = this.detail_product.item.variants.findIndex((e) => e.id === this.form.product_variant_id)
        price = this.$usePosPrice() ? this.detail_product.item.variants[idx].sell_price_pos : this.detail_product.item.variants[idx].sell_price
      }
      return Number(price)
    },
    market_price() {
      let price = this.detail_product.item.market_price
      if (this.form.product_variant_id) {
        const idx = this.detail_product.item.variants.findIndex((e) => e.id === this.form.product_variant_id)
        price = this.detail_product.item.variants[idx].market_price
      }
      return price
    },
    image_product() {
      const images = []
      if (this.form.product_variant_id) {
        const idx = this.detail_product.item.variants.findIndex((e) => e.id === this.form.product_variant_id)
        if (this.detail_product.item.variants[idx].all_photos.length > 0) {
          for (let i = 0; i < this.detail_product.item.variants[idx].all_photos.length; i++) {
            images.push(this.detail_product.item.variants[idx].all_photos[i].photo_md)
          }
        } else {
          images.push(this.detail_product.item.photo_md)
        }
      } else {
        if (this.detail_product.type === 'product') {
          if (this.detail_product.item.all_photos.length > 0) {
            for (let x = 0; x < this.detail_product.item.all_photos.length; x++) {
              images.push(this.detail_product.item.all_photos[x].photo_md)
            }
          } else {
            images.push(this.detail_product.item.photo_md)
          }
        } else {
          images.push(this.detail_product.item.photo_md)
        }
      }
      return images
    },
    sub_total() {
      let total_addons = 0

      // addons product utama
      if (this.item_addons.length > 0) {
        for (let i = 0; i < this.item_addons.length; i++) {
          if (this.item_addons[i]) {
            total_addons += Number((this.detail_product.item.addons[i].total_price != null ? this.detail_product.item.addons[i].total_price : this.detail_product.item.addons[i].price))
          }
        }
      }

      // addons combo
      for (let i = 0; i < this.combo_addons.length; i++) {
        const group = this.combo_addons[i]
        if (!group) continue

        for (let j = 0; j < group.length; j++) {
          const addonState = group[j]
          if (addonState.selected) {
            total_addons += Number(addonState.addon.price)
          }
        }
      }

      return (Number(this.price) + total_addons) * this.form.qty
    },
    list_note() {
      let arr = []
      if (this.detail_product.item.predefined_order_notes) {
        const str = this.detail_product.item.predefined_order_notes
        arr = str.split(',')
      }
      return arr
    },
    disabled() {
      if (this.form.qty > 0) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    item_addons(newItem) {
      this.form.addons = []
      for (let i = 0; i < newItem.length; i++) {
        if (newItem[i]) {
          this.form.addons.push({
            product_addon_id: this.detail_product.item.addons[i].id,
            product_addon_name: this.detail_product.item.addons[i].name,
            product_addon_price: Number((this.detail_product.item.addons[i].total_price != null ? this.detail_product.item.addons[i].total_price : this.detail_product.item.addons[i].price)),
            product_addon_product_id: this.detail_product.item.addons[i].product_id,
            product_addon_variant_id: this.detail_product.item.addons[i].variant_id,
            product_addon_stock: this.detail_product.item.addons[i].stock_qty,
            product_addon_hold: this.detail_product.item.addons[i].hold_qty,
            product_addon_qty: this.detail_product.item.addons[i].product_qty,
            track_inventory: this.detail_product.item.addons[i].track_inventory,
            is_out_stock: this.detail_product.item.addons[i].is_out_stock
          })
        }
      }
    },
    tempSelectedCommodity: {
      deep: true,
      handler(val) {
        if (!val.length) return
        this.$emit('update:selectedCommodity', [...val])
        this.form.product_combo_items = [...val]

        const newComboAddons = val.map((item, idx) => {
          const prev = this.combo_addons[idx]

          if (
            prev &&
            prev.length === (item.addons || []).length
          ) {
            return prev
          }

          return (item.addons || []).map(addon => ({
            addon,
            selected: false
          }))
        })

        this.combo_addons = newComboAddons
      }
    },
    'selectedIdxCommodity.selectedCommodity'(val) {
      if (this.selectedIdxCommodity.combo_index !== null) {
        this.$set(
          this.tempSelectedCommodity,
          this.selectedIdxCommodity.combo_index,
          val
        )
      }
    }
  },
  mounted() {
    this.loadCart()
    this.defaultAddons()
    this.setDefaultData()
  },
  methods: {
    loadCart() {
      const LOCAL_DATA_CART = localStorage.getItem(
        process.env.VUE_APP_COOKIE_KEY + '_v2_cart'
      )

      const localCart = LOCAL_DATA_CART
        ? JSON.parse(LOCAL_DATA_CART)
        : {}
      
      this.cart = Object.keys(localCart).length > 0
        ? localCart
        : { item: [] }

    },
    imageLoadError(event) {
      event.target.src = require('@/assets/images/product_not_available.png')
    },
    async setDefaultData() {
      this.selectedCommodity = []
      this.tempSelectedCommodity = []
      this.form.product_combo_items = []
      if (this.detail_product.type === 'product' && this.detail_product.item.variants.length === 0 && this.detail_product.item.has_material && !this.detail_product.item.track_inventory) {
        await this.checkStockMaterialObj({
          product_id: Number(this.detail_product.item.id)
        })
      }
      if (!this.$isEmpty(this.defaultData)) {
        this.form.addons = this.defaultData.addons
        this.form.has_material = this.defaultData.has_material
        this.form.hold_qty = this.defaultData.hold_qty
        this.form.is_out_stock = this.defaultData.is_out_stock
        this.form.klasifikasi_id = this.defaultData.klasifikasi_id
        this.form.materials = this.defaultData.materials
        this.form.min_order = this.defaultData.min_order
        this.form.max_order = this.defaultData.max_order
        this.form.name = this.defaultData.name
        this.form.non_service_charge = this.defaultData.non_service_charge
        this.form.non_taxable = this.defaultData.non_taxable
        this.form.note = this.defaultData.note
        this.form.product_combo_id = this.defaultData.product_combo_id
        this.form.product_id = this.defaultData.product_id
        this.form.product_variant_id = this.defaultData.product_variant_id
        this.form.product_variant_name = this.defaultData.product_variant_name
        this.form.qty = this.defaultData.qty
        this.form.sell_price = this.defaultData.sell_price
        this.form.stock_qty = this.defaultData.stock_qty
        this.form.sub_total = this.defaultData.sub_total
        this.form.track_inventory = this.defaultData.track_inventory
        this.form.is_takeaway = this.defaultData.is_takeaway

        this.commodity.map((item, idx) => {
          for (let i = 0; i < item.length; i++) {
            const index = this.defaultData.product_combo_items.findIndex((e) => {
              return item[i].id === e.id && item[i].children_id === e.children_id
            })

            if (index !== -1) {
              this.$set(this.tempSelectedCommodity, idx, item[i])
              break
            }
          }
        })

        this.$nextTick(() => {
          this.defaultData.product_combo_items.forEach((comboItem, idx) => {
            if (!comboItem.addons || !this.combo_addons[idx]) return

            comboItem.addons.forEach(savedAddon => {
              const addonIndex = this.combo_addons[idx].findIndex(a =>
                a.addon.id === savedAddon.product_addon_id
              )

              if (addonIndex !== -1) {
                this.combo_addons[idx][addonIndex].selected = true
              }
            })
          })
        })

        if (this.defaultData.product_variant_id) {
          const arr = this.defaultData.product_variant_name.split(',')
          this.variant_group = arr
        }

        if (!this.defaultData.product_combo_id) {
          this.detail_product.item.addons.map((item, idx) => {
            for (let i = 0; i < this.defaultData.addons.length; i++) {
              if (item.id === this.defaultData.addons[i].product_addon_id) {
                this.$set(this.item_addons, idx, true)
              }
            }
          })
        }
      } else {
        this.form.is_takeaway = false
        this.commodity.map((item, idx) => {
          let selected = item[0]

          for (let i = 0; i < item.length; i++) {
            if (!item[i].disabled) {
              selected = item[i]
              break
            }
          }

          this.$set(this.tempSelectedCommodity, idx, selected)
        })
      }
    },
    defaultAddons() {
      if (this.detail_product.item.addons && this.detail_product.item.addons.length !== 0) {
        for (let i = 0; i < this.detail_product.item.addons.length; i++) {
          this.item_addons[i] = false
        }
      }
    },
    async deleteItem() {
      this.closeSheet()
      await this.clickDelete()
    },
    closeSheet() {
      this.detail_product.sheet = false
      document.querySelector('html').style.overflowY = 'scroll'
    },
    async selectVariant() {
      const variant = this.detail_product.item.variants.findIndex((e) => e.name === this.variant_group.toString())
      if (variant !== -1) {
        this.form.product_variant_id = Number(this.detail_product.item.variants[variant].id)
        this.form.product_variant_name = this.detail_product.item.variants[variant].name
        if (this.detail_product.item.has_material && !this.detail_product.item.track_inventory) {
          await this.checkStockMaterialObj({
            product_variant_id: Number(this.detail_product.item.variants[variant].id)
          })
        }
      }
    },
    // validateData(type) {
    //   if (type !== 'product') {
    //     return this.validateComboStock()
    //   }

    //   const productCheck = this.validateProductStock()
    //   if (!productCheck.valid) return productCheck

    //   const addonCheck = this.validateAddonStock(this.form.addons)
    //   if (!addonCheck.valid) return addonCheck

    //   return productCheck
    // },
    async validateData(type) {
      const data = {
        valid: true,
        message: '',
        hold_qty: this.detail_product.item.hold_qty,
        is_out_stock: this.detail_product.item.is_out_stock,
        stock_qty: this.detail_product.item.stock_qty
      }
      if (type === 'product') {
        if (this.detail_product.item.track_inventory && this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
          if (this.detail_product.item.variants.length > 0) {
            if (!this.form.product_variant_id) {
              data.valid = false
              data.message = this.$t('v2.complete_the_required_fields')
            } else {
              const stock_incart = this.$stockCart(this.form.product_variant_id, '_v2_cart', 'variant')
              const idx = this.detail_product.item.variants.findIndex((e) => e.id === this.form.product_variant_id)
              data.valid = Number(this.detail_product.item.variants[idx].stock_qty) - Number(this.detail_product.item.variants[idx].hold_qty) >= (Number(this.form.qty) + stock_incart) && !this.detail_product.item.variants[idx].is_out_stock
              data.message = this.$t('v2.stock_is_not_enough', { data: this.detail_product.item.name + ' (' + this.detail_product.item.variants[idx].name + ')' })
              data.hold_qty = this.detail_product.item.variants[idx].hold_qty
              data.is_out_stock = this.detail_product.item.variants[idx].is_out_stock
              data.stock_qty = this.detail_product.item.variants[idx].stock_qty
            }
          } else {
            const stock_incart = this.$stockCart(this.detail_product.item.id, '_v2_cart', 'product')
            data.valid = Number(this.detail_product.item.stock_qty) - Number(this.detail_product.item.hold_qty) >= (Number(this.form.qty) + stock_incart) && !this.detail_product.item.is_out_stock
            data.message = this.$t('v2.stock_is_not_enough', { data: this.detail_product.item.name })
          }
        } else if (!this.detail_product.item.track_inventory && this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
          if (this.detail_product.item.variants.length > 0) {
            if (!this.form.product_variant_id) {
              data.valid = false
              data.message = this.$t('v2.complete_the_required_fields')
            } else {
              const idx = this.detail_product.item.variants.findIndex((e) => e.id === this.form.product_variant_id)
              data.valid = this.checkStockMaterials()
              data.message = this.$t('v2.the_material_is_not_enough', { data: this.detail_product.item.name + ' (' + this.detail_product.item.variants[idx].name + ')' })
              data.hold_qty = this.detail_product.item.variants[idx].hold_qty
              data.is_out_stock = this.detail_product.item.variants[idx].is_out_stock
              data.stock_qty = this.detail_product.item.variants[idx].stock_qty
            }
          } else {
            data.valid = this.checkStockMaterials()
            data.message = this.$t('v2.the_material_is_not_enough', { data: this.detail_product.item.name })
          }
        } else {
          if (this.detail_product.item.variants.length > 0) {
            if (!this.form.product_variant_id) {
              data.valid = false
              data.message = this.$t('v2.complete_the_required_fields')
            } else {
              const idx = this.detail_product.item.variants.findIndex((e) => e.id === this.form.product_variant_id)
              data.valid = !this.detail_product.item.variants[idx].is_out_stock
              data.message = this.$t('v2.stock_is_not_enough', { data: this.detail_product.item.name + ' (' + this.detail_product.item.variants[idx].name + ')' })
              data.hold_qty = this.detail_product.item.variants[idx].hold_qty
              data.is_out_stock = this.detail_product.item.variants[idx].is_out_stock
              data.stock_qty = this.detail_product.item.variants[idx].stock_qty
            }
          } else {
            data.valid = !this.detail_product.item.is_out_stock
            data.message = this.$t('v2.stock_is_not_enough', { data: this.detail_product.item.name })
          }
        }
      } else {
        if (this.form.product_combo_items.length > 0 && this.detail_product.item.items.length === this.form.product_combo_items.length) {
          for (let i = 0; i < this.form.product_combo_items.length; i++) {
            if (typeof this.form.product_combo_items[i] === 'undefined') {
              data.valid = false
              data.message = this.$t('v2.complete_the_required_fields')
              break
            } else {
              data.hold_qty = 0
              data.is_out_stock = this.detail_product.item.is_out_stock
              data.stock_qty = Number(this.detail_product.item.stock_qty)
              if (this.form.product_combo_items[i].published) {
                if (this.form.product_combo_items[i].track_inventory) {
                  if (this.form.product_combo_items[i].variant_id !== '') {
                    const stock_incart = this.$stockCart(this.form.product_combo_items[i].variant_id, '_v2_cart', 'variant')
                    data.valid = Number(this.form.product_combo_items[i].stock_qty) - Number(this.form.product_combo_items[i].hold_qty) >= ((Number(this.form.qty) * this.form.product_combo_items[i].qty) + stock_incart) && !this.form.product_combo_items[i].is_out_stock
                    data.message = this.$t('v2.stock_is_not_enough', { data: this.form.product_combo_items[i].name })
                    if (data.valid === false) {
                      break
                    }
                  } else {
                    const stock_incart = this.$stockCart(this.form.product_combo_items[i].id, '_v2_cart', 'product')
                    data.valid = Number(this.form.product_combo_items[i].stock_qty) - Number(this.form.product_combo_items[i].hold_qty) >= ((Number(this.form.qty) * this.form.product_combo_items[i].qty) + stock_incart) && !this.form.product_combo_items[i].is_out_stock
                    data.message = this.$t('v2.stock_is_not_enough', { data: this.form.product_combo_items[i].name })
                    if (data.valid === false) {
                      break
                    }
                  }
                } else {
                  data.valid = !this.form.product_combo_items[i].is_out_stock
                  data.message = this.$t('v2.stock_is_not_enough', { data: this.form.product_combo_items[i].name })
                  if (data.valid === false) {
                    break
                  }
                }
              } else {
                data.valid = false
                data.message = this.$t('v2.products_have_not_been_published', { item: this.form.product_combo_items[i].name })
                break
              }
            }
          }
        } else {
          data.valid = false
          data.message = this.$t('v2.complete_the_required_fields')
        }
      }
      return data
    },
    validateProductStock() {
      const disallowNoStock = this.$store.state.selected_outlet.pos_disallow_sell_no_stock
      const item = this.detail_product.item

      const mustCheckStock = item.track_inventory && disallowNoStock

      if (item.variants.length > 0) {
        if (!this.form.product_variant_id) {
          return {
            valid: false,
            message: this.$t('v2.complete_the_required_fields')
          }
        }

        const variant = item.variants.find(v => v.id === this.form.product_variant_id)

        if (!variant) {
          return {
            valid: false,
            message: this.$t('v2.product_not_found')
          }
        }

        if (variant.is_out_stock) {
          return {
            valid: false,
            message: this.$t('v2.stock_is_not_enough', {
              data: `${item.name} (${variant.name})`
            })
          }
        }

        if (mustCheckStock) {
          const stock_incart = this.$stockCart(
            this.form.product_variant_id,
            '_v2_cart',
            'variant',
            this.isEdit,
            this.detail_product.key
          )

          const available = Number(variant.stock_qty) - Number(variant.hold_qty)

          if (available < Number(this.form.qty) + stock_incart) {
            return {
              valid: false,
              message: this.$t('v2.stock_is_not_enough', {
                data: `${item.name} (${variant.name})`
              })
            }
          }
        }

        return {
          valid: true,
          hold_qty: variant.hold_qty,
          is_out_stock: variant.is_out_stock,
          stock_qty: variant.stock_qty
        }
      }

      // product tanpa variant
      if (item.is_out_stock) {
        return {
          valid: false,
          message: this.$t('v2.stock_is_not_enough', { data: item.name })
        }
      }

      if (mustCheckStock) {
        const stock_incart = this.$stockCart(
          item.id,
          '_v2_cart',
          'product',
          this.isEdit,
          this.detail_product.key
        )

        const available = Number(item.stock_qty) - Number(item.hold_qty)

        if (available < Number(this.form.qty) + stock_incart) {
          return {
            valid: false,
            message: this.$t('v2.stock_is_not_enough', { data: item.name })
          }
        }
      }

      return {
        valid: true,
        hold_qty: item.hold_qty,
        is_out_stock: item.is_out_stock,
        stock_qty: item.stock_qty
      }
    },
    validateComboStock() {
      const disallowNoStock = this.$store.state.selected_outlet.pos_disallow_sell_no_stock
      if (!this.form.product_combo_items.length || this.detail_product.item.items.length !== this.form.product_combo_items.length) {
        return {
          valid: false,
          message: this.$t('v2.complete_the_required_fields')
        }
      }

      for (let i = 0; i < this.form.product_combo_items.length; i++) {
        const item = this.form.product_combo_items[i]
        if (!item) {
          return {
            valid: false,
            message: this.$t('v2.complete_the_required_fields')
          }
        }

        if (!item.published) {
          return {
            valid: false,
            message: this.$t('v2.products_have_not_been_published', {
              item: item.name
            })
          }
        }

        if (item.is_out_stock) {
          return {
            valid: false,
            message: this.$t('v2.stock_is_not_enough', { data: item.name })
          }
        }

        const mustCheckStock = item.track_inventory && disallowNoStock
        const requiredQty = Number(this.form.qty) * Number(item.qty)

        if (mustCheckStock) {
          const isVariant = item.variant_id !== '' && item.variant_id !== null

          const id = isVariant ? item.variant_id : item.id
          const type = isVariant ? 'variant' : 'product'

          const stock_incart = this.$stockCart(
            id,
            '_v2_cart',
            type,
            this.isEdit,
            this.detail_product.key
          )

          const available = Number(item.stock_qty) - Number(item.hold_qty)

          if (available < requiredQty + stock_incart) {
            return {
              valid: false,
              message: this.$t('v2.stock_is_not_enough', { data: item.name })
            }
          }
        }

        const addonCheck = this.validateAddonStock(item.addons)
        if (!addonCheck.valid) return addonCheck
      }

      return { valid: true }
    },
    validateAddonStock(addons) {
      if (!addons || addons.length === 0) {
        return { valid: true }
      }

      for (let i = 0; i < addons.length; i++) {
        const addon = addons[i]
        const check = this.checkStockAddons(addon)

        if (!check.valid) {
          return {
            valid: false,
            message: this.$t('v2.stock_is_not_enough', {
              data: check.product_name
            })
          }
        }
      }

      return { valid: true }
    },
    async addToCart() {
      this.form.product_combo_items = this.tempSelectedCommodity.map((item, idx) => {
        const selectedAddons = []

        if (this.combo_addons[idx]) {
          this.combo_addons[idx].forEach((addonState) => {
            if (addonState.selected) {
              const addon = addonState.addon

              selectedAddons.push({
                product_addon_id: addon.id,
                product_addon_name: addon.name,
                product_addon_price: Number(addon.price),
                product_addon_product_id: addon.product_id,
                product_addon_variant_id: addon.variant_id,
                product_addon_stock: addon.stock_qty,
                product_addon_hold: addon.hold_qty,
                product_addon_qty: addon.product_qty,
                track_inventory: addon.track_inventory,
                is_out_stock: addon.is_out_stock
              })
            }
          })
        }

        return {
          ...item,
          addons: selectedAddons
        }
      })
      const result = this.$canOrder(
        this.detail_product.item.id,
        this.form.qty,
        this.detail_product.item.min_order,
        this.detail_product.item.max_order,
        '_v2_cart',
        this.isEdit ? 'edit' : 'add',
        this.isEdit ? this.detail_product.key : null
      )
      if (!result.valid) {
        this.alert.show = true
        this.alert.message = result.message
        return
      }
      let validStock = await this.validateData(this.detail_product.type)

      // if (this.detail_product.type !== 'product') {
      const materialStock = await this.validateStockMaterial()
      validStock = {
        ...validStock,
        valid: validStock.valid && materialStock.valid,
        message: !validStock.valid ? validStock.message : !materialStock.valid
          ? materialStock.message
          : ''
      }
      // }
      if (!validStock.valid) {
        this.alert.show = true
        this.alert.message = validStock.message
        this.error_variant = true
        return
      } else {
        this.form.hold_qty = validStock.hold_qty
        this.form.is_out_stock = validStock.is_out_stock
        this.form.stock_qty = validStock.stock_qty
        this.form.min_order = Number(this.detail_product.item.min_order)
        this.form.max_order = Number(this.detail_product.item.max_order)
        this.form.name = this.detail_product.item.name
        this.form.non_taxable = this.detail_product.item.non_taxable
        this.form.non_service_charge = typeof this.detail_product.item.non_service_charge !== 'undefined' ? this.detail_product.item.non_service_charge : 0
        if (this.detail_product.type === 'product') {
          this.form.product_id = this.detail_product.item.id
          this.form.klasifikasi_id = this.detail_product.item.klasifikasi_id
        } else {
          this.form.product_combo_id = this.detail_product.item.id
          this.form.klasifikasi_id = null
        }
        this.form.sell_price = this.price
        this.form.sub_total = this.sub_total
        this.form.track_inventory = this.detail_product.item.track_inventory

        if (this.form.materials.length > 0) {
          for (let i = 0; i < this.form.materials.length; i++) {
            this.form.materials[i].qty_in_cart = Number(this.form.qty) * Number(this.form.materials[i].qty)
          }
        }
        await this.clickAddcart(this.form, this.detail_product.type, this.detail_product.method)
        this.closeSheet()
      }
    },
    openDialogNote() {
      this.dialog.list_note = true
      this.listnote = []
    },
    saveNote() {
      for (let i = 0; i < this.list_note.length; i++) {
        if (this.listnote[i]) {
          if (this.form.note === '') {
            this.form.note = this.list_note[i]
          } else {
            this.form.note = this.form.note + ', ' + this.list_note[i]
          }
        }
      }
      this.dialog.list_note = false
    },
    plus() {
      this.form.qty = this.form.qty + 1
    },
    minus() {
      this.form.qty = this.form.qty - 1
    },
    async checkStockMaterialObj(objId) {
      try {
        const { data } = await checkStockMaterial(objId)
        this.form.materials = data.data.materials
      } catch (e) {
        this.form.materials = []
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    checkStockMaterials() {
      let is_available = true
      if (this.form.materials.length > 0) {
        for (let m = 0; m < this.form.materials.length; m++) {
          if (this.form.materials[m].product_out_stock) {
            is_available = false
            break
          } else {
            if (this.form.materials[m].material_product_variant_id) {
              if (Number(this.form.materials[m].track_inventory) === 1) {
                if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                  if (this.$stockCart(this.form.materials[m].material_product_variant_id, '_v2_cart', 'variant', this.isEdit, this.detail_product.key) + (this.form.qty * Number(this.form.materials[m].qty)) > (Number(this.form.materials[m].product_stock_qty) - Number(this.form.materials[m].product_hold_qty))) {
                    is_available = false
                    break
                  }
                }
              }
            } else {
              if (Number(this.form.materials[m].track_inventory) === 1) {
                if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                  if (this.$stockCart(this.form.materials[m].material_product_id, '_v2_cart', 'product', this.isEdit, this.detail_product.key) + (this.form.qty * Number(this.form.materials[m].qty)) > (Number(this.form.materials[m].product_stock_qty) - Number(this.form.materials[m].product_hold_qty))) {
                    is_available = false
                    break
                  }
                }
              }
            }
          }
        }
      }
      return is_available
    },
    getCartItemIdentity(item) {
      const addonsKey = (item.addons || [])
        .map(a => `${a.product_addon_id}-${a.product_addon_variant_id || ''}`)
        .sort()
        .join(',')
      const comboItemsKey = (item.product_combo_items || [])
        .map(c => `${c.id}-${c.children_id || ''}-${c.variant_id || ''}`)
        .sort()
        .join(',')
      return [
        item.product_id,
        item.product_combo_id,
        item.product_variant_id,
        item.note || '',
        addonsKey,
        comboItemsKey
      ].join('|')
    },
    async validateStockMaterial() {
      const obj = {
        valid: true,
        message: ''
      }
      try {
        const temp_item = { ...this.form }
        if (this.detail_product.type === 'product') {
          temp_item.product_id = this.detail_product.item.id
          temp_item.klasifikasi_id = this.detail_product.item.klasifikasi_id
        } else {
          temp_item.product_combo_id = this.detail_product.item.id
          temp_item.klasifikasi_id = null
        }
        if (this.isEdit) {
          this.temp_cart.item = [temp_item]
        } else {
          const existingIndex = this.cart.item.findIndex((e) => this.getCartItemIdentity(e) === this.getCartItemIdentity(temp_item))
          if (existingIndex === -1) {
            this.temp_cart.item = [...this.cart.item, temp_item]
          } else {
            const mergedItem = { ...this.cart.item[existingIndex] }
            mergedItem.qty = Number(mergedItem.qty) + Number(temp_item.qty)
            if (mergedItem.materials && mergedItem.materials.length && temp_item.materials && temp_item.materials.length) {
              mergedItem.materials = mergedItem.materials.map((material) => {
                const newMaterial = temp_item.materials.find((m) => m.material_product_id === material.material_product_id)
                return {
                  ...material,
                  qty_in_cart: Number(material.qty_in_cart) + Number(newMaterial ? newMaterial.qty_in_cart : 0)
                }
              })
            }
            this.temp_cart.item = [
              ...this.cart.item.slice(0, existingIndex),
              mergedItem,
              ...this.cart.item.slice(existingIndex + 1)
            ]
          }
        }
        await validateMaterial(this.temp_cart)
        return obj
      } catch (e) {
        this.form.product_combo_items = []
        delete this.temp_cart.item
        obj.valid = false
        obj.message = e.string
        return obj
      }
    },
    checkStockAddons(item) {
      const obj = {
        valid: true,
        product_name: ''
      }

      if (!item.track_inventory) {
        return obj
      }

      if (item.is_out_stock) {
        obj.valid = false
        obj.product_name = item.product_addon_name
        return obj
      }

      if (!this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
        return obj
      }

      let stockAddonsInCart = 0

      const isVariant = item.product_addon_variant_id !== null && item.product_addon_variant_id !== ''
      const id = isVariant ? item.product_addon_variant_id : item.product_addon_product_id
      const type = isVariant ? 'variant' : 'product'
      stockAddonsInCart = this.$stockCart(id, '_v2_cart', type, this.isEdit, this.detail_product.key)
      const requiredQty = Number(this.form.qty) * Number(item.product_addon_qty)
      const available = Number(item.product_addon_stock) - Number(item.product_addon_hold)

      if (stockAddonsInCart + requiredQty > available) {
        obj.valid = false
        obj.product_name = item.product_addon_name
      }

      return obj
    },
    openCombo(idx) {
      this.$emit('listcombo', {
        index: idx,
        commodity: this.commodity[idx],
        selected: this.tempSelectedCommodity[idx]
      })
    },
    buildCommodityItem(item, list, isChild = false) {
      if (item.product_has_variant) {
        this.buildVariantItems(item, list, isChild)
      } else {
        list.push(this.buildSingleItem(item, isChild))
      }
    },
    buildVariantItems(item, list, isChild) {
      const variants = item.variant || []

      if (variants.length && item.product_variant_id === 0) {
        variants.forEach(v => {
          list.push(this.buildVariantObject(item, v, isChild))
        })
      } else {
        const variant =
          variants.find(v => v.id === item.product_variant_id) || variants[0]

        if (variant) {
          list.push(this.buildVariantObject(item, variant, isChild))
        }
      }
    },
    buildVariantObject(item, variant, isChild) {
      const stock_incart = item.product_track_inventory
        ? this.$stockCart(variant.id, '_v2_cart', 'variant', this.isEdit, this.detail_product.key)
        : 0

      const disabled = item.product_track_inventory
      // ? !(Number(item.product_stock_qty) - Number(item.product_hold_qty) >= (Number(item.qty) + stock_incart)) ||
        ? !(Number(variant.stock_qty) - Number(variant.hold_qty) >= (Number(item.qty) + stock_incart)) ||
          Boolean(variant.is_out_stock)
        : Boolean(variant.is_out_stock)

      return {
        id: isChild ? item.parent_id : item.id,
        children_id: isChild ? item.id : '',
        variant_id: variant.id,
        name: `${item.product_name} (${variant.name})`,
        image: variant.photo_md,
        disabled,
        qty: Number(item.qty),
        stock_qty: Number(variant.stock_qty),
        hold_qty: Number(variant.hold_qty),
        is_out_stock: variant.is_out_stock,
        track_inventory: item.product_track_inventory,
        published: item.published,
        addons: item.addons || []
      }
    },
    buildSingleItem(item, isChild) {
      const stock_incart = item.product_track_inventory
        ? this.$stockCart(item.product_id || item.id, '_v2_cart', 'product', this.isEdit, this.detail_product.key)
        : 0

      const disabled = item.product_track_inventory
        ? !(Number(item.product_stock_qty) - Number(item.hold_qty) >= (Number(item.qty) + stock_incart)) ||
          Boolean(item.product_is_out_stock)
        : Boolean(item.product_is_out_stock)

      return {
        id: isChild ? item.parent_id : item.id,
        children_id: isChild ? item.id : '',
        variant_id: '',
        name: item.product_name,
        image: item.photo_md,
        disabled,
        qty: Number(item.qty),
        stock_qty: Number(item.product_stock_qty),
        // hold_qty: Number(item.product_hold_qty),
        hold_qty: Number(item.hold_qty),
        is_out_stock: item.product_is_out_stock,
        track_inventory: item.product_track_inventory,
        published: item.published,
        addons: item.addons || []
      }
    }
  }
}
</script>
<style>
  .sheet-app-bar {
    contain: layout;
    display: block;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    max-width: 100%;
    height: 72px;
    margin-top: 0px;
    transform: translateY(0px);
    left: 0px;
    right: 0px;
  }
  .sheet-app-bar-content {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    z-index: 0;
    height: 72px;
    padding: 4px 16px;
  }
  .image-product-detail{
    margin-right: -12px;
    margin-left: -12px;
  }
  .title-product-detail{
    font-size: 20px;
    font-weight: 700;
    color: #272727;
  }
  .desc-product-detail{
    flex: 1 1 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    white-space: normal;
    line-clamp: 3;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    font-size: 14px;
    color: #767676;
    line-height: 19.1px;
  }
  .desc-product-detail.is-more{
    line-clamp: 1000;
    -webkit-line-clamp: 1000;
  }
  .more-less{
    display: flex;
    font-size: 14px;
    font-weight: 700;
    color: #0078CE;
  }
  .font-price{
    font-size: 20px;
    font-weight: 700;
    color: #0078CE;
  }
  .font-price > .market-price{
    color: #a0a0a0;
    text-decoration: line-through;
    margin-left: 8px;
    font-size: 14px;
  }
  .title-section-text {
    font-size: 16px;
    font-weight: 600;
    color: #272727;
    line-height: 21.82px;
  }
  .title-section-subtext {
    font-size: 12px;
    font-weight: 400;
    color: #767676;
    line-height: 16.37px;
  }
  .title-combo-subtext {
    overflow: hidden;
    color: #272727;
    text-overflow: ellipsis;
    font-family: Nunito;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .title-section-subtext.error-variant {
    color: #F44336;
  }
  .list-variant-tag .v-input__control,
  .list-variant-tag .v-input__slot {
    width: 100% !important;
  }
  .group-list-combo {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
  }
  .list-frame-item-combo {
    display: flex;
    flex-direction: column;
    align-self: stretch;
    border-radius: 5px;
    border: 1px solid #CECECE;
  }
  .line-item-combo {
    width: calc(100% - 32px);
    height: 0.5px;
    background-color: #CECECE;
    margin: auto;
  }
  .group-addons-combo {
    display: flex;
    padding: 8px 0;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    background-color: #FAFAFA;
  }
  .group-addons-title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    flex: 1 0 0;
    width: 100%;
    color: #272727;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .list-variant-tag-item:not(:last-child):not(:only-child){
    margin-bottom: 4px !important;
  }
  .list-variant-tag-item {
    min-height: 40px;
    width: 100% !important;
    justify-content: space-between !important;
  }
  .list-variant-tag-item > label {
    order: 0;
    font-size: 14px;
    color: #272727 !important;
  }
  .list-variant-tag-item > .v-input--selection-controls__input{
    order: 1;
  }
  .line-variant{
    margin: auto;
    border: none;
    border-width: thin 0 0;
    height: 0.5px;
    background-color: #CECECE;
  }
  .addons-item {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 100%;
    flex: 1 1 100%;
    letter-spacing: normal;
    min-height: 40px;
    outline: none;
    position: relative;
    text-decoration: none;
    width: 100%;
  }
  .addons-item-content{
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-flex: 1;
    -ms-flex: 1 1;
    flex: 1 1;
    overflow: hidden;
  }
  .addons-item-title {
    line-height: normal;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 100%;
    flex: 1 1 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    font-size: 14px;
    font-weight: 400;
  }
  .addons-item-action {
    display: flex;
    align-items: center;
    margin-left: 8px;
  }
  .image-full > .v-carousel {
    display: block;
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto auto;
    width: 100%;
    height: 100% !important;
    object-fit: cover;
  }
  .image-full > .v-carousel .v-responsive{
    height: 100% !important;
  }
  .carousel-product .v-carousel__controls {
    background: none;
  }
  .carousel-product .v-carousel__controls > .v-item-group{
    background-color: #FFFFFFB8;
    border-radius: 100px;
    display: flex;
  }
  .carousel-product .v-carousel__controls__item{
    width: 8px;
    height: 8px;
    margin: 8px;
    border: solid 1px #767676;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .carousel-product .v-carousel__controls__item.v-item--active {
    color: #767676;
  }
  .carousel-product .v-carousel__controls__item .v-icon{
    font-size: 8px !important;
    height: 8px;
    width: 8px;
    opacity: 1;
  }
  .qty-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .v-btn.btn-plus-minus {
    background-color: #fff !important;
    box-shadow: 0px 2px 2px 0px #0000001f;
    border-radius: 5px !important;
  }
  .col-order-cashier{
    background-color: #FFF2E3;
    padding: 16px;
    border-radius: 10px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 100%;
    flex: 1 1 100%;
    letter-spacing: normal;
    outline: none;
    position: relative;
    text-decoration: none;
  }
  .order-cashier-content{
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-flex: 1;
    -ms-flex: 1 1;
    flex: 1 1;
    overflow: hidden;
  }
  .order-cashier-text{
    line-height: normal;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 100%;
    flex: 1 1 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    font-size: 14px;
    font-weight: 400;
    color: #272727;
  }
  .order-cashier-icon{
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    line-height: normal;
    position: relative;
    text-align: center;
    vertical-align: middle;
    overflow: hidden;
    margin-right: 8px;
  }
</style>
